export const pageTypes = {
  PROJECT: 'project',
  SCENARIO: 'scenario',
  FLOW_GROUP: 'flow_group',
  FLOW: 'flow'
}
